@if (menuParams) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="menuParams">
          <div class="control-div">
            <label class="control-label">Channel Display Type (Default)</label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'displayType'"></app-cms>
            <display-type-btn (change)="displayChange($event)" [data]="displayTypeModalData" [hasCountWarning]="false"></display-type-btn>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label">Menu Header</label>
              <label class="control-optional">Optional</label>
            </div>
            <input class="control-input" [formControlName]="'menuHeader'" placeholder="Name the menu header"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Sub Header </label>
              <label class="control-optional">Optional</label>
            </div>
            <input class="control-input" [formControlName]="'groupTitle'" placeholder="Add a subheader"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Message To User </label>
            </div>
            <ng-container *ngTemplateOutlet="validators; context: { myControlName: 'bodyText', myForm: menuParams}">
            </ng-container>
            <textarea class="control-textArea" [formControlName]="'bodyText'" placeholder="Enter a message to user"></textarea>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Variable Name </label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'varNameDynamicList'"></app-cms>
            </div>
            <ng-container *ngTemplateOutlet="validators; context: { myControlName: 'varName', myForm: menuParams}">
            </ng-container>
            <input class="control-input" [formControlName]="'varName'" placeholder="Enter name for variable"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> List Option Pattern </label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'listOptionPattern'"></app-cms>
            </div>
            <ng-container *ngTemplateOutlet="validators; context: { myControlName: 'optionPattern', myForm: menuParams}">
            </ng-container>
            <input class="control-input" [formControlName]="'optionPattern'" placeholder="Add list option pattern"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> List Value Pattern </label>
              <label class="control-optional">Optional</label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'listValuePattern'"></app-cms>
            </div>
            <input class="control-input" [formControlName]="'valuePattern'" placeholder="Add list value pattern"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> List Description Pattern </label>
              <label class="control-optional">Optional</label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'listDescriptionPattern'"></app-cms>
            </div>
            <input class="control-input" [formControlName]="'descriptionPattern'" placeholder="Add list description / subtext pattern"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Option Separator </label>
              <app-cms class="popover" [type]="'nodeBuild'" [field]="'optSeperatorDynamicList'"></app-cms>
            </div>
            <mat-select [formControlName]="'optionSeperator'" class="control-dropdown" hideSingleSelectionIndicator>
              <div class="customSeparator_content">
                <input #inputSeparator class="customSeparator_input" type="text"
                  placeholder="Add custom separator" (keydown.space)="$event.stopPropagation()"
                                (keydown.enter)="addSeparator($event, inputSeparator.value);
                                inputSeparator.value = ''"/>
                            <button class="customSeparator_btn" (click)=" addSeparator($event, inputSeparator.value);
                            inputSeparator.value = ''">
                  </button>
                </div>
                @for (option of optionSeperatorList; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                }
              </mat-select>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Filter By </label>
                <label class="control-optional">Optional</label>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'filterBy'"></app-cms>
              </div>
              <ng-container *ngTemplateOutlet="patternValueValidator; context: { patternControlName: 'filterByPattern', valueControlName: 'filterByValue', myForm: menuParams}">
              </ng-container>
              <input class="control-input" [formControlName]="'filterByPattern'" placeholder="Pattern" required="menuParams.controls['filterByValue'].value !== ''"/>
              <input class="control-input margin-top-5" [formControlName]="'filterByValue'" placeholder="Value" required="menuParams.controls['filterByPattern'].value !== ''"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Exclude </label>
                <label class="control-optional">Optional</label>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'exclude'"></app-cms>
              </div>
              <ng-container *ngTemplateOutlet="patternValueValidator; context: { patternControlName: 'excludePattern', valueControlName: 'excludeValue', myForm: menuParams}"></ng-container>
              <input class="control-input" [formControlName]="'excludePattern'" placeholder="Pattern" required="menuParams.controls['excludeValue'].value !== ''"/>
              <input class="control-input margin-top-5" [formControlName]="'excludeValue'" placeholder="Value" required="menuParams.controls['excludePattern'].value !== ''"/>
            </div>
            <div class="control-div control-div-toggle">
              <div class="label-left-block">
                <label class="control-label"> Enable Pagination </label>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'enablePagination'"></app-cms>
              </div>
              <!--(change)="addOptionsToTheGroups($event)"-->
              <div class="toggle-btn" >
                <mat-slide-toggle #paginationToggle [color]="'primary'" class="control-toggle"
                  [formControlName]="'pagination'" >
                </mat-slide-toggle>
              </div>
            </div>
            @if (paginationToggle.checked) {
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Next Option Title </label>
                </div>
                <input class="control-input" [formControlName]="'nextOptionTitle'" placeholder="Next"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Previous Option Title </label>
                </div>
                <input class="control-input" [formControlName]="'previousOptionTitle'" placeholder="Back"/>
              </div>
            }
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
      <clickatell-expansion-panel>
        <ng-container header>
          <mat-panel-title>
            Logic
          </mat-panel-title>
        </ng-container>
        <ng-container body>
          <ng-container [formGroup]="menuParams">
            <div class="control-div logic">
              <div class="control-label-container-set">
                <div class="logic-title-container">
                  <img src='../../../../../../../../../assets/svg/redesign/Check_Mark_Filled.svg' alt='' class="logic-title-image" />
                  <label class="control-label-header"> Success </label>
                </div>
                <ng-container [formGroup]="menuParams">
                  <div class="control-div adjust">
                    <label class="control-label"> Point To </label>
                    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    @if (nodeFlowDetails) {
                      <next-selector
                        [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'success'"
                        [form]="menuParams"
                        [selectedValue]="getformValue(menuParams, 'success')"
                        [stepId]="nodeFlowDetails.stepId">
                        >
                      </next-selector>
                    }
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="control-div logic">
              <div class="control-label-container-set">
                <div class="logic-title-container">
                  <img src='../../../../../../../../../assets/svg/redesign/alert-circle-filled.svg' alt='' class="logic-title-image" />
                  <label class="control-label-header"> Error </label>
                </div>
                <ng-container [formGroup]="menuParams">
                  <div class="control-div adjust">
                    <label class="control-label"> Point To </label>
                    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    @if (nodeFlowDetails) {
                      <next-selector
                        [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'error'"
                        [form]="menuParams"
                        [selectedValue]="getformValue(menuParams, 'error')"
                        [stepId]="nodeFlowDetails.stepId">
                        >
                      </next-selector>
                    }
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="control-div logic">
              <div class="control-label-container-set">
                <div class="logic-title-container">
                  <img src='../../../../../../../../../assets/svg/redesign/Check_Mark_Filled.svg' alt='' class="logic-title-image" />
                  <label class="control-label-header"> Default </label>
                </div>
                <ng-container [formGroup]="menuParams">
                  <div class="control-div adjust">
                    <div class="control-label-container">
                      <label class="control-label"> Point To </label>
                      <label class="control-optional">Optional</label>
                      <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                    </div>
                    @if (nodeFlowDetails) {
                      <next-selector
                        [canEditFlows]="canEdit.canEditFlows"
                        [selectorType]="'both'"
                        [flowSteps]="nodeFlowDetails.currentFlowSteps"
                        [flows]="nodeFlowDetails.flows"
                        [name]="'default'"
                        [form]="menuParams"
                        [selectedValue]="getformValue(menuParams, 'default')"
                        [stepId]="nodeFlowDetails.stepId"
                        [isOptional]="true">
                      </next-selector>
                    }
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </clickatell-expansion-panel>
    </div>
  }

  <ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
    @if (myForm.controls[myControlName]; as control) {
      @if (control.invalid && (control.dirty || control.touched)) {
        <div class="validationField">
          @for (error of control.errors | keyvalue; track error) {
            <div>
              <span class="fa fa-exclamation-circle"></span>
              <span [id]="'validationField-' + myControlName">
                {{error.value}}
              </span>
            </div>
          }
        </div>
      }
    }
  </ng-template>

  <ng-template #patternValueValidator let-patternControlName="patternControlName" let-valueControlName="valueControlName" let-myForm=myForm>
    @if (myForm.controls[patternControlName] && myForm.controls[valueControlName]) {
      @if ((menuParams.controls[patternControlName].value !== '' && menuParams.controls[valueControlName].value === '') || (menuParams.controls[patternControlName].value === '' && menuParams.controls[valueControlName].value !== '')) {
        <div class="validationField">
          <span class="fa fa-exclamation-circle"></span>
          <span id="validationField-exclude">
            Pattern and Value both required
          </span>
        </div>
      }
    }
  </ng-template>
